import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_DESKTOP_REVIEW_FILTERS',
  'GET_DESKTOP_REVIEW_JOBS',
  'GET_DESKTOP_REVIEW_ALL_JOBS',
  'GET_DESKTOP_REVIEW_PARTNER',
  'GET_DESKTOP_REVIEW_JOB_DOCUMENTS',
  'GET_DESKTOP_REVIEW_JOB',
  'ADD_DESKTOP_REVIEW_JOB',
  'GET_DESKTOP_REVIEW_JOB_TEST_PLANS',
  'GET_DESKTOP_REVIEW_JOB_SUMMARY',
  'GET_SUPPLIERS_LIST',
  'GET_DESKTOP_REVIEW_DASHBOARD',
  'UPDATE_DESKTOP_REVIEW_JOB',
  'UPDATE_DESKTOP_REVIEW_JOB_STATUS',
  "GET_DESKTOP_REVIEW_PRODUCTS",
  "UPDATE_DESKTOP_REVIEW_JOB_FILTER",
);
